import { drizzle } from 'drizzle-orm/neon-http';
import { neon, neonConfig } from '@neondatabase/serverless';
import * as schema from './schema';

// Suppress the warning about running SQL from the browser
// We are using a serverless driver which is designed for this use case
neonConfig.disableWarningInBrowsers = true;

if (!import.meta.env.VITE_DATABASE_URL) {
  throw new Error('VITE_DATABASE_URL is not set');
}

const sql = neon(import.meta.env.VITE_DATABASE_URL);
export const db = drizzle(sql, { schema });

export * from './schema';